var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuConcorrencia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.561,
    height: 31.861,
    viewBox: "0 0 32.561 31.861",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu-concorrencia",
    transform: "translate(0 -5.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1535",
    "data-name": "Caminho 1535",
    d: "M125.673,16.337l-.251,4.2a1.453,1.453,0,0,0,.6,1.273,1.419,1.419,0,0,0,1.365.167l3.818-1.532,3.819,1.535a1.419,1.419,0,0,0,1.365-.167,1.453,1.453,0,0,0,.6-1.273l-.25-4.2,2.616-3.243a1.462,1.462,0,0,0,.251-1.379,1.44,1.44,0,0,0-1-.95l-3.975-1.05-2.209-3.54a1.43,1.43,0,0,0-2.432,0l-2.209,3.539-3.974,1.051a1.44,1.44,0,0,0-1,.95,1.462,1.462,0,0,0,.251,1.379Zm-1.658-4.223a.168.168,0,0,1,.118-.116l4.218-1.115a.636.636,0,0,0,.377-.278l2.342-3.753a.158.158,0,0,1,.274,0l2.343,3.754a.636.636,0,0,0,.377.278L138.282,12a.168.168,0,0,1,.118.116.191.191,0,0,1-.032.184l-2.77,3.434a.641.641,0,0,0-.141.4c0,.013,0,.025,0,.038l.264,4.443a.183.183,0,0,1-.075.165.146.146,0,0,1-.148.019l-4.056-1.63a.636.636,0,0,0-.474,0L126.914,20.8a.146.146,0,0,1-.147-.019.183.183,0,0,1-.075-.166l.266-4.444a.636.636,0,0,0-.14-.437l-2.77-3.432a.191.191,0,0,1-.032-.184Z",
    transform: "translate(-114.927)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1536",
    "data-name": "Caminho 1536",
    d: "M31.925,299.115h-2.9v-7.19a.636.636,0,0,0-.636-.636H20.952v-4.264a.636.636,0,0,0-.636-.636H12.245a.636.636,0,0,0-.636.636v2.086H4.174a.636.636,0,0,0-.636.636v9.368H.636a.636.636,0,1,0,0,1.272H31.925a.636.636,0,0,0,0-1.272ZM4.81,290.383h6.8v8.732H4.81Zm8.071-2.722h6.8v11.454h-6.8Zm8.071,11.454V292.56h6.8v6.555Z",
    transform: "translate(0 -263.025)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1537",
    "data-name": "Caminho 1537",
    d: "M238.8,359.845a.636.636,0,0,0-.636-.636h-1.234a.636.636,0,0,0-.019,1.272v2.193a.636.636,0,0,0,.019,1.272h1.234a.636.636,0,0,0,.019-1.272v-2.193A.636.636,0,0,0,238.8,359.845Z",
    transform: "translate(-221.271 -331.214)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuConcorrencia);
export default __webpack_public_path__ + "static/media/menu-concorrencia.b83aaf9a5fab0c381aa3cbff066b8f6a.svg";
export { ForwardRef as ReactComponent };